export const itStrings = {
    'Play': 'Play',
    'Pause': 'Pausa',
    'Current Time': 'Orario attuale',
    'Duration': 'Durata',
    'Remaining Time': 'Tempo rimanente',
    'Stream Type': 'Tipo del Streaming',
    'LIVE': 'LIVE',
    'Loaded': 'Caricato',
    'Progress': 'Stato',
    'Fullscreen': 'Schermo intero',
    'Non-Fullscreen': 'Chiudi schermo intero',
    'Mute': 'Muto',
    'Unmute': 'Audio',
    'Playback Rate': 'Tasso di riproduzione',
    'Subtitles': 'Sottotitoli',
    'subtitles off': 'Disattiva sottotitoli',
    'Captions': 'Sottotitoli',
    'captions off': 'Disattiva sottotitoli',
    'Chapters': 'Capitolo',
    'You aborted the media playback': 'La riproduzione del filmato è stata interrotta.',
    'A network error caused the media download to fail part-way.': 'Il download del filmato è stato interrotto a causa di un problema rete.',
    'The media could not be loaded, either because the server or network failed or because the format is not supported.': 'Il filmato non può essere caricato a causa di un errore nel server o nella rete o perché il formato non viene supportato.',
    'The media playback was aborted due to a corruption problem or because the media used features your browser did not support.': 'La riproduzione del filmato è stata interrotta a causa di un file danneggiato o per l’utilizzo di impostazioni non supportate dal browser.',
    'No compatible source was found for this media.': 'Non ci sono fonti compatibili per questo filmato.',
    'subtitles settings': 'Opzioni sottotitoli',
    'captions settings': 'Opzioni sottotitoli',
    'Text': 'Testo',
    'White': 'Bianco',
    'Black': 'Nero',
    'Red': 'Rosso',
    'Green': 'Verde',
    'Blue': 'Blu',
    'Yellow': 'Giallo',
    'Magenta': 'Magenta',
    'Cyan': 'Ciano',
    'Background': 'Sfondo',
    'FontSize': 'Dimensione caretteri',
    'Text Edge Style': 'Stile bordo testo',
    'None': 'Nessuno',
    'Raised': 'Rialzato',
    'Depressed': 'Riquadro',
    'Uniform': 'Uniforme',
    'Dropshadow': 'Con ombra',
    'FontFamily': 'Stile carattere',
    'Window': 'Finestra',
    'Transparent': 'Transparente',
    'SemiTransparent': 'Semi Transparente',
    'Reset': 'Reimposta',
    'Done': 'Fatto',
};
// Some strings can't be translated like this because of the videojs menu creation which does not use those strings
